import validator from "validator";

export const PublishSurveyValidation = (data) => {
  const errors = {};

  if (validator.isEmpty(data?.title?.trim())) {
    errors.title = "*Title is required";
  }

  if (validator.isEmpty(data?.description?.trim())) {
    errors.description = "*Description is required";
  }

  if (data?.category === undefined || data?.category === "") {
    errors.category = "*Category is required";
  }
  if (data?.questions?.length === 0) {
    errors.questions = "*At least one question is required";
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};

export const EditSurveyShareDataValidation = (data) => {
  const errors = {};

  // Only require audience (department) if not in fan mode
  if (!data?.isFanMode && data?.audience?.length === 0) {
    errors.audience = "*Survey team is required";
  }

  if (!data?.endHeading) {
    errors.endHeading = "*Survey end heading is required";
  } else {
    if (validator.isEmpty(data?.endHeading?.trim())) {
      errors.endHeading = "*Survey end heading is required";
    }
  }

  if (data?.email) {
    // Modern email regex that handles longer TLDs
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    const emails = data?.email?.split(",").map((email) => email.trim());
    console.log(emails);
    const invalidEmails = emails.filter((email) => email && !regex.test(email));

    if (invalidEmails.length > 0) {
      errors.email = "Invalid email address";
    }
  }

  if (!data?.endBody) {
    errors.endBody = "*Survey end body is required";
  } else {
    if (validator.isEmpty(data?.endBody?.trim())) {
      errors.endBody = "*Survey end body is required";
    }
  }

  return { errors, isValid: Object.keys(errors).length <= 0 };
};